import { Accordion, AccordionDetails, AccordionSummary, FormControl, FormControlLabel, FormLabel, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import React, { useState } from "react";
import { SingleRouteResponseOfRoadFeatures, SingleRouteResponseOfRoadFeaturesWithBruksklasse, SourceReferenceSystem } from "../../../services/RuteplanAPI";
import { StringInput } from "../../common/StringInput";
import { RouteDownloadButton } from "./RouteDownloadButton";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export interface IRouteDownloadProps {
    route: SingleRouteResponseOfRoadFeaturesWithBruksklasse | SingleRouteResponseOfRoadFeatures;
    fileName: string;
}

type CoordinateSystem = SourceReferenceSystem.EPSG_4326 | SourceReferenceSystem.EPSG_25833;

export function RouteDownload(props: IRouteDownloadProps) {
    const {route} = props;

    const [fileName, setFileName] = useState(props.fileName);
    const [coordinateSystem, setCoordinateSystem] = useState<CoordinateSystem>(SourceReferenceSystem.EPSG_4326);
    const [expanded, setExpanded] = useState<boolean>(false);


    React.useEffect(() => {
        setFileName(props.fileName);
    }, [props.fileName])

    const onAccordionClicked = () => {
        setExpanded( (prevState) => !prevState);
    }

    return (
    <Accordion expanded={expanded} onClick={onAccordionClicked} variant="elevation">
        <AccordionSummary expandIcon={<ArrowDropDownIcon/>} style={{paddingLeft: "0px", paddingRight: "0px"}}>
            <Typography>Eksporter rute</Typography>            
        </AccordionSummary>
        <AccordionDetails onClick={(event) => event.stopPropagation()}>
            <Paper style={{paddingLeft: "10px"}} elevation={0}>
            <StringInput key={route.routeName + route.routeId + "ruteInput"} label="Filnavn" value={props.fileName} onChange={(value) => setFileName(value)} />
            <FormControl>
                <FormLabel> Koordinatsystem</FormLabel>
                <RadioGroup row defaultValue={SourceReferenceSystem.EPSG_4326} onChange={(event) => setCoordinateSystem(event.target.value as CoordinateSystem)}>
                    <FormControlLabel value={SourceReferenceSystem.EPSG_4326} control={<Radio />} label="EPSG_4326" />
                    <FormControlLabel value={SourceReferenceSystem.EPSG_25833} control={<Radio />} label="EPSG_25833" />
                </RadioGroup>
            </FormControl>
            <RouteDownloadButton key={route.routeId + "downloadButton"} routeName={route.routeName} fileName={fileName} coordinateSystem={coordinateSystem} />        
            </Paper>
        </AccordionDetails>
    </Accordion>
    )
}